<cerrix-loader [cerrixTab]="parentTab"></cerrix-loader>

@if (showSave) {
    <div class="detail-page-action-bar flex-action-bar">
        <div>
            <button
                data-uiid="button-save"
                class="btn btn-cerrix"
                (click)="saveNotificationPreference()"
            >
                <i class="fas fa-save"></i>
                <span class="d-none d-lg-inline">{{ 'notificationSettings.saveButton' | t }}</span>
            </button>
        </div>
    </div>
}

<div class="detail-page-card">
    <div class="detail-page-card-title">{{ 'notificationSettings.title' | t }}</div>
    <div class="detail-page-card-body padded">
        <label for="notificationPreferenceSelect">{{ 'notificationSettings.preferenceLabel' | t }}</label>
        <cerrix-select
            id="notificationPreferenceSelect"
            [prettyName]="'notificationSettings.preferenceLabel' | t"
            bindValue="ID"
            bindLabel="Name"
            [getDataMethod]="notificationOptions"
            [(ngModel)]="userModel.notificationPreference"
            [multiple]="false"
            [closeOnSelect]="true"
            dataUiid="user-notification-preference-select"
        >
        </cerrix-select>
    </div>
</div>

<div class="detail-page-card">
    <div class="detail-page-card-title">{{ 'notificationSettings.slackStatusTitle' | t }}</div>
    <div class="detail-page-card-body padded">
        <div>
            <label>{{ slackStatusKey | t }}</label>
        </div>
        <div>
            <button data-uiid="button-sync" class="btn btn-success" (click)="syncUser()">
                <i class="fas fa-sync"></i>
                <span class="d-none d-lg-inline">{{ 'notificationSettings.linkSlackButton' | t }}</span>
            </button>
        </div>
    </div>
</div>
